exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-add-new[data-v-249dfe84] {\n  position: sticky;\n  bottom: -7px;\n  background-color: white;\n  z-index: 1;\n  border-top: 1px solid #e0e0e0;\n}\n.sticky-add-new .v-list-item[data-v-249dfe84] {\n  padding: 12px 16px;\n}\n.sticky-add-new .v-list-item[data-v-249dfe84]:hover {\n  background-color: #f5f5f5;\n}\n", ""]);

// exports
